import ResponseError from "@/errors/ResponseError";

export type FetchJsonResponse<T> = Promise<T | null>;
/**
 * Make a fetch request and return the parsed JSON response body.
 * @param {(Request|string|URL)} resource - the resource (request or URL) to
 * query for
 *
 * @return {Promise<Object>} the parsed JSON response body
 */
const fetchJson = async <T = object>(
  resource: RequestInfo | URL,
  init?: RequestInit,
): FetchJsonResponse<T> => {
  const defaultInit = init || {};
  if (resource instanceof Request) {
    resource.headers.set("Content-Type", "application/json");
  }
  const response = await fetch(resource, {
    credentials: "include",
    ...defaultInit,
  });
  if (!response.ok) {
    // getting text version of the response body
    // to assign the response body to the error's message property
    throw new ResponseError(response, await response.text());
  }

  if (response.headers.get("Content-Length") === "0") {
    return null;
  }

  if (response.status === 204) {
    return null;
  }

  return await response.json();
};

export default fetchJson;
